module.exports = {
  ACTIVE_CUSTOMER_PIECHART_REQUEST: "ACTIVE_CUSTOMER_PIECHART_REQUEST",
  ACTIVE_CUSTOMER_PIECHART_SUCCESS: "ACTIVE_CUSTOMER_PIECHART_SUCCESS",
  ACTIVE_CUSTOMER_PIECHART_FAIL: "ACTIVE_CUSTOMER_PIECHART_FAIL",
  SUBSCRIPTION_PIECHART_DETAILS: "SUBSCRIPTION_PIECHART_DETAILS",
  SUPPORT_TICKET_PIECHART_DETAILS: "SUPPORT_TICKET_PIECHART_DETAILS",
};
